<script setup lang="ts">
const config = useRuntimeConfig();
useScript({
  src: "https://www.meanthemes.com/demo/meanmenu/jquery.meanmenu.js",
  defer: true,
});

const { data: categories } = await useFetch<ArtworkCategory[]>("/api/artwork-categories");

const logoUrl = useState<string>("logo-url");
const logoFooterUrl = useState<string>("logo-footer-url");

onMounted(async () => {
  // @ts-ignore
  $(".xboot-mobile-menu").meanmenu();
});
// const { data: artworks } = await useFetch<Artwork[]>(`/api/artworks`);
</script>

<template>
  <header class="header-area header-style-one">
    <div class="header-middle-area">
      <div class="container">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-3">
            <div class="logo">
              <NuxtLink href="/"><img height="50" :src="logoUrl" alt="Met Devoti Logo" /></NuxtLink>
            </div>
          </div>
          <div class="col-md-10 col-sm-10 hidden-xs hidden-sm">
            <div class="menu-area">
              <nav>
                <ul class="main-menu clearfix hover-style-one">
                  <li>
                    <NuxtLink to="/artworks"
                      >Artworks <span><i class="fa fa-angle-down"></i></span
                    ></NuxtLink>
                    <ul>
                      <li v-for="value in categories" :key="value.id">
                        <NuxtLink :to="`/artworks/${value.slug}`">{{ value.title }}</NuxtLink>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <NuxtLink to="/blog">Blog</NuxtLink>
                  </li>
                  <li>
                    <a href="#"
                      >About<span><i class="fa fa-angle-down"></i></span
                    ></a>
                    <ul>
                      <li>
                        <NuxtLink to="/about-me">Me</NuxtLink>
                      </li>
                      <li>
                        <NuxtLink to="/press">Press</NuxtLink>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <NuxtLink to="/contact">Contact</NuxtLink>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <div class="clearfix"></div>
          <!-- Mobile menu area start -->
          <div class="xboot-mobile-menu-area hidden-md hidden-lg">
            <div class="col-sm-12">
              <nav class="xboot-mobile-menu">
                <ul>
                  <li>
                    <NuxtLink to="/">Home</NuxtLink>
                  </li>
                  <li>
                    <NuxtLink to="/artworks">Artworks</NuxtLink>
                    <ul>
                      <li v-for="value in categories" :key="value.id">
                        <NuxtLink :to="`/artworks/${value.slug}`">{{ value.title }}</NuxtLink>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <NuxtLink to="/blog">Blog</NuxtLink>
                  </li>
                  <li>
                    <NuxtLink to="/about-me">About Me</NuxtLink>
                    <ul>
                      <li>
                        <NuxtLink to="/press">Press</NuxtLink>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <NuxtLink to="/contact">Contact</NuxtLink>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <!-- Mobile menu area end -->
        </div>
      </div>
    </div>
  </header>
</template>
<style>
.mean-container a.meanmenu-reveal {
  border-color: var(--title-color);
  color: var(--title-color);
}

.mean-container a.meanmenu-reveal span {
  background: var(--title-color);
}

@media (max-width: 767px) {
  .mean-container a.meanmenu-reveal {
    margin-right: 2rem;
  }
}
</style>
